import { tickerItems } from '@/mocks/home';

export default function UpdateTicker() {
  const loop = [...tickerItems, ...tickerItems];

  return (
    <div id="update" className="bg-primary-700 text-background-50">
      <div className="max-w-screen-xl mx-auto px-4 md:px-6">
        <div className="flex items-center gap-3 md:gap-4 h-9 md:h-10 text-xs md:text-sm">
          <span className="flex items-center gap-2 shrink-0 font-medium">
            <span className="relative flex w-2.5 h-2.5 items-center justify-center">
              <span className="absolute inline-flex w-full h-full rounded-full bg-accent-400 animate-ping-soft"></span>
              <span className="relative inline-flex w-2.5 h-2.5 rounded-full bg-accent-400"></span>
            </span>
            <span className="whitespace-nowrap">实时更新</span>
          </span>

          <span className="w-px h-4 bg-background-50/30 shrink-0"></span>

          <div className="ticker-mask flex-1 overflow-hidden">
            <div className="flex w-max animate-ticker">
              {loop.map((item, index) => (
                <span
                  key={`${item}-${index}`}
                  className="whitespace-nowrap pr-10 text-background-50/90"
                >
                  {item}
                </span>
              ))}
            </div>
          </div>

          <span className="hidden lg:flex items-center gap-1.5 shrink-0 text-background-50/80 whitespace-nowrap">
            <i className="ri-time-line"></i>
            更新于 09:12
          </span>
        </div>
      </div>
    </div>
  );
}